<template>
  <form>
    <card footer-classes="text-right" :header-classes="{ 'text-right': $rtl.isRTL }">
      <!-- <div slot="header"><h4 class="card-title">استمارة التسجيل في مسابقة جامع سناو لحفظ القرآن الكريم (الثامنة)
1441هـ/2019م</h4></div> -->
<div slot="header"><h4 class="card-title">تم الإنتهاء من فترة التسجيل</h4></div>
      <!-- <div>
        <base-input placeholder="الرقم المدني (من البطاقة أو الجواز أو شهادة الميلاد)"
          type="text"
          label="الرقم المدني أو الجواز"
          v-model="model.nationalId"
          :class="{'text-right': $rtl.isRTL }"
        >
        </base-input>

        <base-input placeholder="رقم النقال مثال: ٩٩٩٩٩٩٩٩"
          label="رقم النقال"
          v-model="model.mobileNo"
          :class="{'text-right': $rtl.isRTL }"
        >
        </base-input>

        <base-input placeholder="مثال: عبدالله بن عبدالله بن عبدالله الفلاني"
          type="text"
          label="الاسم الثلاثي مع القبيلة"
          v-model="model.name"
          :class="{'text-right': $rtl.isRTL }"
        >
        </base-input>
         
        <base-input
          label="سنة الميلاد"
          :class="{'text-right': $rtl.isRTL }"
        >
            <el-date-picker
            v-model="model.dob"
            type="year"
            placeholder="اختر سنة الميلاد"
            @change="calculateYear"
            >
            </el-date-picker>
        </base-input>
        
        <base-input
        label="النوع"
        :class="{'text-right': $rtl.isRTL }"
        >

        <base-radio 
        name="male" 
        v-model="model.gender"
        >
        ذكر
        </base-radio>
        
        <base-radio
        name="female" 
        v-model="model.gender"
        >
        أنثى
        </base-radio>
        </base-input>
        
        <base-input
            label="المستوى"
            :class="{'text-right': $rtl.isRTL }"
            >

            <base-radio 
            name="1" 
            v-model="model.level"
            v-show="level.one"
            >
            الاول
            </base-radio>
            
            <base-radio 
            name="2" 
            v-model="model.level"
            v-show="level.two"
            >
            الثاني
            </base-radio>

            <base-radio 
            name="3" 
            v-model="model.level"
            v-show="level.three"
            >
            الثالث
            </base-radio>

            <base-radio 
            name="4" 
            v-model="model.level"
            v-show="level.four"
            >
            الرابع
            </base-radio>

            <base-radio 
            name="5" 
            v-model="model.level"
            v-show="level.five"
            >
            الخامس
            </base-radio>

            <base-radio 
            name="6" 
            v-model="model.level"
            v-show="level.six"
            >
            السادس
            </base-radio>

            <base-radio 
            name="7" 
            v-model="model.level"
            v-show="level.seven"
            >
            السابع
            </base-radio>

            <base-radio 
                name="8" 
                v-model="model.level"
                v-show="level.eight"
            >
            الثامن
            </base-radio>

            <base-radio 
            name="9" 
            v-model="model.level"
            v-show="level.nine"
            >
            التاسع
            </base-radio>

            <base-radio 
            name="10" 
            v-model="model.level"
            v-show="level.ten"
            >
            العاشر
            </base-radio>

            <base-radio 
            name="11" 
            v-model="model.level"
            v-show="level.eleven"
            >
            الحادي عشر
            </base-radio>

            <base-radio 
            name="12" 
            v-model="model.level"
            v-show="level.tweleve"
            >
            الثاني عشر
            </base-radio>
        </base-input>

         <base-input placeholder="مثال: سناو/المغدر"
          type="text"
          label="اسم المدينة والقرية"
          v-model="model.city"
          :class="{'text-right': $rtl.isRTL }"
        >
        </base-input>

        <base-input
            label="صورة البطاقة أو الجواز أو شهادة الميلاد"
            :class="{'text-right': $rtl.isRTL }"
        >
        <image-upload @change="onImageChange" select-text="اختر الصورة" />  
        </base-input>
      </div> -->
      <!-- <template :class="{'text-right': $rtl.isRTL }">
        <collapse :multiple-active="false" :class="{'text-right': $rtl.isRTL }">
            <collapse-item title="شروط المسابقة" name="1">
                <div>
                    <ul slot="raw-content" class="list-group list-group-flush">
                        <li class="list-group-item">•	حفظ الأجزاء متتالية.</li>
                        <li class="list-group-item">•	كل من سبق له المشاركة وتأهل إلى التصفية الثانية يلزم بأخذ مستوى أعلى.</li>
                        <li class="list-group-item">•	المسابقة للقاطنين ولاية المضيبي ونيابتي سناو وسمد، أو الدارسين في المراكز الصيفية في هذه المناطق.</li>
                    </ul>
                </div>
            </collapse-item>
            <collapse-item title="موعد التسميع" name="2">
                <div>
                    <ul slot="raw-content" class="list-group list-group-flush">
                        <li class="list-group-item">•	التصفية الأولى، يوم السبت، (8، محرم،1441هـ)- (7/9/2019م) في (جامع سناو)،. (- من المستوى الأول إلى الرابع سيتم التسميع لهم من الساعة (7:00صباحا) إلى (10:00صباحا) ذكورا وإناثا. (ومن المستوى الخامس إلى الثاني عشر سيتم التسميع لهم من الساعة (4:30عصرا) إلى (6:00 عصرا)، ذكورا وإناثا</li>
                        <li class="list-group-item">•	يسمع لأصحاب الأعذار بعد هذا التأريخ بأسبوعين، يوم السبت، الساعة التاسعة صباحا. (22، محرم ،1441هـ)- (21/9/2019م)، بشرط تواصل أصحاب الأعذار على الرقم الآتي: 96249966.</li>
                        <li class="list-group-item">•	التصفية الثانية: يوم السبت، (29، محرم، 1441هـ)-(28/9/2019م) في جامع سناو، من الساعة السابعة صباحا، إلى الساعة العاشرة صباحا.</li>
                    </ul>
                </div>
            </collapse-item>
            <collapse-item title="تنبيه" name="3">
                <div>
                    <ul slot="raw-content" class="list-group list-group-flush">
                        <li class="list-group-item">آخر موعد لملء استمارة التسجيل: الاثنين، 3 /محرم/ 1441هـ، 2/9/2019م ولن ينظر في أي طلب بعد هذا التأريخ. </li>
                    </ul>
                </div>
            </collapse-item>
            <collapse-item title="ملاحظات" name="3">
                <div>
                    <ul slot="raw-content" class="list-group list-group-flush">
                        <li class="list-group-item">•	يصح للأقل فئة عمرية أن يسمع في المستوى الأعلى.     </li>
                        <li class="list-group-item">•	التسميع يشمل الرجال والنساء، وستُفرد لجان خاصة من النساء للمتسابقات في المستويات المفتوحة.</li>
                        <li class="list-group-item">•	يلزم إرفاق شهادة ميلاد أو جواز سفر للفئات العمرية التي تتطلب سنا معينا.</li>
                        <li class="list-group-item">•	يلزم التسميع مع التجويد في كل المستويات ما عدا الأول والثاني.</li>
                        <li class="list-group-item">•	إن سمع أقل من عشرة أشخاص في مستو من مستويات المسابقة فتلغى التصفية الثانية في ذلك المستوى، وتعتمد نتائج التصفية الأولى.</li>
                    </ul>
                </div>
            </collapse-item>
            <collapse-item title="مواعيد التسميع" name="3">
                <div>
                    <ul slot="raw-content" class="list-group list-group-flush">
                        <li class="list-group-item"> من المستوى الأول إلى الرابع سيتم التسميع لهم من الساعة (7:00 صباحا) إلى (10:00 صباحا) ذكورا وإناثا</li>
                        <li class="list-group-item">ومن المستوى الخامس إلى الثاني عشر سيتم التسميع لهم من الساعة (4:30عصرا) إلى (6:00 عصرا)، ذكورا وإناثا</li>
                    </ul>
                </div>
            </collapse-item>
            <collapse-item title="مستويات مسابقة جامع سناو لحفظ القرآن الكريم" name="3">
                <div>
                    <ul slot="raw-content" class="list-group list-group-flush">
                        <li class="list-group-item">•	جزء واحد	المستوى الأول- مواليد 2011م وما فوق- </li>
                        <li class="list-group-item">•	جزءان	-المستوى الثاني - مواليد 2009م وما فوق</li>
                        <li class="list-group-item">•	ثلاثة أجزاء	-المستوى الثالث -مواليد 2007م وما فوق</li>
                        <li class="list-group-item">•	أربعة أجزاء	المستوى الرابع - مواليد 2006م وما فوق</li>
                        <li class="list-group-item">•	خمسة أجزاء	المستوى الخامس - مواليد 2005م وما فوق</li>
                        <li class="list-group-item">•	ستة أجزاء	المستوى السادس - مواليد 2004م وما فوق</li>
                        <li class="list-group-item">•	ثمانية أجزاء	المستوى السابع - مفتوح لجميع الأعمار</li>
                        <li class="list-group-item">•	عشرة أجزاء	المستوى الثامن - مفتوح لجميع الأعمار</li>
                        <li class="list-group-item">•	خمسة عشر جزءا	المستوى التاسع - مفتوح لجميع الأعمار</li>
                        <li class="list-group-item">•	عشرون جزءا	المستوى العاشر - مفتوح لجميع الأعمار</li>
                        <li class="list-group-item">•	خمسة وعشرون جزءا	المستوى الحادي عشر - مفتوح لجميع الأعمار	</li>
                        <li class="list-group-item">•	ثلاثون جزءا	المستوى الثاني عشر - مفتوح لجميع الأعمار</li>
                    </ul>
                </div>
            </collapse-item> -->
            <!-- <collapse-item title="طريقة تقييم مسابقة جامع سناو لحفظ القرآن الكريم الثامنة" name="3">
                <div>
                    <ul slot="raw-content" class="list-group list-group-flush">
                        <li class="list-group-item">•	لا يوجد تجويد في المستويين الأول والثاني، يقتصر على الحفظ فقط.</li>
                        <li class="list-group-item">•	الخطأ في الحفظ والشكل يحسب درجة.</li>
                        <li class="list-group-item">•	التنبيه الأول على الخطأ يحسب نصف درجة إلا في المستويين الأول والثاني، فيسجل الخطأ على التنبيه الثاني.</li>
                        <li class="list-group-item">	•	الخطأ في التجويد يحسب نصف درجة، ويكون التقييم في أحكام النون الساكنة والتنوين والميم الساكنة والقلقلة والمدود فقط.</li>
                        <li class="list-group-item">	•	يسمع للمتسابق في المستوى الأول والثاني أربعة مواضع فقط، كل موضع نصف صفحة.</li>
                        <li class="list-group-item">	•	يسمع للمتسابق في المستوى الثالث والرابع والخامس والسادس خمسة مواضع فقط، كل موضع نصف صفحة.</li>
                        <li class="list-group-item">	•	يسمع للمتسابق في المستوى السابع والثامن والتاسع والعاشر والحادي عشر والثاني عشر خمسة مواضع كل موضع صفحة كاملة.</li>
                        <li class="list-group-item">	•	الدرجة من (100) فإن كانت المواضع أربعة فكل سؤال له (25) درجة وإن كانت خمسة فكل سؤال له (20) درجة.</li>
                        <li class="list-group-item">	•	تتكون اللجنة من شخصين، يقوم كلاهما برصد الدرجات، ثم أخذ متوسط الدرجات في حال الاختلاف.</li>
                        <li class="list-group-item">	•	إن لم يكن المتسابق قد حفظ المقطع الذي طلب منه أن يتلوه أعطي صفرا.</li>
                        <li class="list-group-item">	•	أصحاب الأعذار من النساء وغيرهم يمكنهم أن يسمعوا عقب أسبوعين من موعد المسابقة في جامع سناو.</li>
                        <li class="list-group-item">	•	كل من سبق له المشاركة في مستوى معين وتأهل إلى التصفية الثانية يلزم بأخذ مستوى أعلى منه.</li>
                        <li class="list-group-item">	•	كل من حصل على درجة أقل من 75 في المائة لا يصح له أن يتأهل إلى التصفية الثانية ولو لم يوجد غيره في المستوى.</li>
                        <li class="list-group-item">	•	اللجنة التي تقيم مستوى معينا في التصفية الثانية تلزم بالتسميع لجميع المتسابقين في ذلك المستوى لضمان العدالة، والتسميع كذلك لأصحاب الأعذار.</li>
                        <li class="list-group-item">-كل من لم يسجل في قوائم المسابقة لا يدخل إلى قاعة التسميع...إلا إن رأى القائمون على اللجان خطأ ما في التسجيع فيمكن مراعاته. - كل من سمع له خطأ (وهو لم يسجل) فتعد درجته ملغية فورا، وكل من أخذ مستوى ما في الأعوام الماضية وتأهل ولكنه شارك هذه السنة مستواه السابق نفسه في (غفلة من لجنة المسابقة) فتعد نتيجته ملغية.</li>
                        <li class="list-group-item">- إن سمع في مستوى من المستويات أقل من عشرة أشخاص فتلغى التصفية الثانية في ذلك المستوى، وتعتمد نتائج التصفية الأولى.</li>
                        <li class="list-group-item">- إذا لم يحفظ المتسابق في المستويين الأول والثاني مقطعا واحدا من المقاطع الأربعة فيخرج مباشرة من التصفية.</li>
                    </ul>
                </div>
            </collapse-item> -->
            <!-- <collapse-item title="للاستفسار" name="3">
                <div>
                    <ul slot="raw-content" class="list-group list-group-flush">
                        <li class="list-group-item">  للاستفسار يرجى الاتصال على الرقم الآتي: 99341410.</li>
                        <li class="list-group-item"> للمشاركة في المسابقة تلزم بملء استمارة التسجيل الإلكترونية على هذا الرابط : ومن لم يستطع ذلك يلتمس المساعدة من أصحاب الأرقام الآتية: 94296254،  96249966. </li>
                    </ul>
                </div>
            </collapse-item>
        </collapse>
        </template> -->
      <!-- <template slot="footer" class="text-right">
        <base-button
          native-type="submit"
          @click.prevent="onSubmit"
          type="primary"
          >تسجيل</base-button
        >
      </template> -->
    </card>
  </form>
</template>
<script>
import { BaseCheckbox, BaseRadio, ImageUpload, Collapse, CollapseItem } from 'src/components/index'
import {DatePicker, TimeSelect } from 'element-ui'
import swal from 'sweetalert2'
import moment from 'moment'
import firebase from 'firebase'
import { Promise } from 'q'
import { setTimeout } from 'timers'
const axios = require('axios')
var cors_proxy = require('cors-anywhere')
var functions = firebase.functions();
var request = require("request");

export default {
  components: {
    BaseCheckbox,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    BaseRadio,
    ImageUpload,
    Collapse,
    CollapseItem
  },
  data() {
    return {
        level: {
            one: false,
            two: false,
            three: false,
            four: false,
            five: false,
            six:false,
            seven:false,
            eight: false,
            nine: false,
            ten: false,
            eleven: false,
            tweleve: false
        },
        model: {
            nationalId: '',
            name: '',
            dob: '',
            mobileNo: '',
            level: '',
            city: '',
            gender: '',
            imagePath: '',
            resultOne: 0,
            reslutTwo: 0,
            createdDate: null
        },
        images: {
            regular: null
        },
        showRules: false,
        year: null
    };
  },
  methods: {
        onImageChange(file) {
            this.images.regular = file;
            this.model.imagePath = file;
        },
        calculateYear() {
            var d = moment(this.model.dob,"YYYY-MM-DD").year()
            console.log(d)
            this.year = 2019 - d
            if(this.year !== null) {
                if(this.year <= 8) {
                    console.log(this.year)
                    this.level.one = true,
                    this.level.two = true,
                    this.level.three = true,
                    this.level.four = true,
                    this.level.five = true,
                    this.level.six = true,
                    this.level.seven = true,
                    this.level.eight = true,
                    this.level.nine = true,
                    this.level.ten = true,
                    this.level.eleven = true,
                    this.level.tweleve = true
                } else if(this.year === 9 || this.year === 10) {
                    console.log(this.year)
                    this.level.one = false,
                    this.level.two = true,
                    this.level.three = true,
                    this.level.four = true,
                    this.level.five = true,
                    this.level.six = true,
                    this.level.seven = true,
                    this.level.eight = true,
                    this.level.nine = true,
                    this.level.ten = true,
                    this.level.eleven = true,
                    this.level.tweleve = true
                } else if(this.year === 11 || this.year === 12) {
                    console.log(this.year)
                    this.level.one = false,
                    this.level.two = false,
                    this.level.three = true,
                    this.level.four = true,
                    this.level.five = true,
                    this.level.six = true,
                    this.level.seven = true,
                    this.level.eight = true,
                    this.level.nine = true,
                    this.level.ten = true,
                    this.level.eleven = true,
                    this.level.tweleve = true
                } else if(this.year === 13) {
                    console.log(this.year)
                    this.level.one = false,
                    this.level.two = false,
                    this.level.three = false,
                    this.level.four = true,
                    this.level.five = true,
                    this.level.six = true,
                    this.level.seven = true,
                    this.level.eight = true,
                    this.level.nine = true,
                    this.level.ten = true,
                    this.level.eleven = true,
                    this.level.tweleve = true
                } else if(this.year === 14) {
                    console.log(this.year)
                    this.level.one = false,
                    this.level.two = false,
                    this.level.three = false,
                    this.level.four = false,
                    this.level.five = true,
                    this.level.six = true,
                    this.level.seven = true,
                    this.level.eight = true,
                    this.level.nine = true,
                    this.level.ten = true,
                    this.level.eleven = true,
                    this.level.tweleve = true
                } else if(this.year === 15) {
                    console.log(this.year)
                    this.level.one = false,
                    this.level.two = false,
                    this.level.three = false,
                    this.level.four = false,
                    this.level.five = false,
                    this.level.six = true,
                    this.level.seven = true,
                    this.level.eight = true,
                    this.level.nine = true,
                    this.level.ten = true,
                    this.level.eleven = true,
                    this.level.tweleve = true
                } else {
                    console.log(this.year)
                    this.level.one = false,
                    this.level.two = false,
                    this.level.three = false,
                    this.level.four = false,
                    this.level.five = false,
                    this.level.six = false,
                    this.level.seven = true,
                    this.level.eight = true,
                    this.level.nine = true,
                    this.level.ten = true,
                    this.level.eleven = true,
                    this.level.tweleve = true
                }
            }
        },
        convertNumbers2English(string) {
            return string.replace(/[\u0660-\u0669]/g, function (c) {
                return c.charCodeAt(0) - 0x0660;
            }).replace(/[\u06f0-\u06f9]/g, function (c) {
                return c.charCodeAt(0) - 0x06f0;
            });
        },
        async onSubmit() {
            if(this.model.nationalId === '') {
                this.showSwal('nationalIdRequired')
            } else if(this.model.mobileNo === '') {
                this.showSwal('mobileNoRequired')
            } else if(this.model.mobileNo.length !== 8) {
                this.showSwal('mobileNoLength')
            } else if(this.model.name === '') {
                this.showSwal('nameRequired')
            } else if(this.model.dob === '') {
                this.showSwal('dobRequired')
            } else if(this.model.gender === '') {
                this.showSwal('genderRequired')
            } else if(this.model.level === '') {
                this.showSwal('levelRequired')
            } else if(this.model.city === '') {
                this.showSwal('cityRequired')
            } else {
                console.log(this.model)
                this.model.mobileNo = this.convertNumbers2English(this.model.mobileNo)
                this.model.nationalId = this.convertNumbers2English(this.model.nationalId)
                var database = firebase.database()
                await this.writeUserData()
                await this.uploadImage()
                //console.log('before sent SMS')
                // const promise = await this.sendSMS('registerSuccefully');
                // console.log(promise)
                await this.clearfields()
                this.showSwal('suceesfulRegister')
            }
        },
        writeUserData(nationalId) {
            // get total number then add one to it then save the new number
            firebase.database().ref('users/' + this.model.nationalId).set({
                name: this.model.name,
                dob: moment(this.model.dob).format('YYYY-MM-DD'),
                mobileNo: this.model.mobileNo,
                level: this.model.level,
                city: this.model.city,
                gender: this.model.gender,
                imagePath: this.model.imagePath.name,
                resultOne: 0,
                reslutTwo: 0,
                createdDate: moment(Date.now()).format('YYYY-MM-DD'),
                message: ` :تم تسجيلك بنجاح في مسابقة جامع سناو لحفظ القرآن الكريم الثامنة. الرقم المدني ${this.model.nationalId}`
            });
        },
        uploadImage() {
            // Create a child reference
            firebase.storage().ref('users/' + this.model.nationalId).put(this.model.imagePath).then(function(snapshot) {
                console.log('Uploaded a blob or file!');
            });
    
        },
        clearfields() {
            this.model.nationalId = '',
            this.model.name = '',
            this.model.dob = '',
            this.model.mobileNo = '',
            this.model.level = '',
            this.model.city = '',
            this.model.gender = '',
            this.model.imagePath = ''
        },
        sendSMS(message) {
            if(message === 'registerSuccefully') {
                // var sendSMS = firebase.functions().httpsCallable('sendSMS');
                // console.log(sendSMS)
                // sendSMS({text: 'messageText'}).then(function(result) {
                // // Read result of the Cloud Function.
                // var sanitizedMessage = result.data.text;

                // });
            }
        },
        showSwal(message) {
            if(message === 'nationalIdRequired') {
                swal({
                    title: `الرجاء ادخال الرقم المدني او رقم الجواز في الخانة المناسبة`,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill'
                });
            } else if(message === 'mobileNoRequired') {
                swal({
                    title: `الرجاء ادخال رقم النقال في الخانة المناسبة`,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill'
                });
            } else if(message === 'mobileNoLength') {
                swal({
                    title: `الرجاء ادخال رقم نقال يتكون من ٨ ارقام فقط`,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill'
                });
            } else if(message === 'nameRequired') {
                swal({
                    title: `الرجاء ادخال الاسم الثلاثي والقبيلة`,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill'
                });
            } else if(message === 'dobRequired') {
                swal({
                    title: `الرجاء ادخال  تأريخ الميلاد`,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill'
                });
            } else if(message === 'genderRequired') {
                swal({
                    title: `الرجاء اختيار جنس المتسابق/ة`,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill'
                });
            } else if(message === 'levelRequired') {
                swal({
                    title: `الرجاء اختيار المستوى`,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill'
                });
            } else if(message === 'cityRequired') {
                swal({
                    title: `الرجاء ادخال المدينة`,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill'
                });
            } else if(message === 'suceesfulRegister') {
                swal({
                    title: `تم تسجيلك بنجاح ستصلك رسالة نصية خلال اليومين القادمين`,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill'
                });
            } 
    }
  },
  mounted() {
    this.i18n = this.$i18n;
    this.i18n.locale = 'ar';
    this.$rtl.enableRTL();
  }
};
</script>
<style>
.el-date-picker {
  background: #fff !important;
  z-index: 10000;
}
</style>
